import * as Sentry from '@sentry/react';

export function initSentry(appName: 'customer' | 'admin' | 'partner') {
  const dsn = (import.meta as any).env?.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: (import.meta as any).env?.MODE ?? 'production',
    sendDefaultPii: true,
    initialScope: { tags: { app: appName } },
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      /listener indicated an asynchronous response/i,
      /ResizeObserver loop/i,
      /Non-Error promise rejection captured/i,
    ],
  });
}

export { Sentry };
